module.exports = __webpack_public_path__ + "img/cloth_g3_item-14.87cea572.svg";